import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FiSave } from 'react-icons/fi';
import { getConfigs, updateConfig } from '../services/api';

const Config: React.FC = () => {
  const [configs, setConfigs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [editValues, setEditValues] = useState<Record<string, string>>({});

  useEffect(() => { loadConfigs(); }, []);

  const loadConfigs = async () => {
    try {
      const res = await getConfigs();
      setConfigs(res.data.data);
      const vals: Record<string, string> = {};
      res.data.data.forEach((c: any) => { vals[c.configKey] = c.configValue; });
      setEditValues(vals);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleSave = async (key: string) => {
    try {
      await updateConfig({ configKey: key, configValue: editValues[key] });
      toast.success(`${key} updated`);
      loadConfigs();
    } catch (err: any) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="card">
        <h3 className="mb-20">System Configuration</h3>
        <p style={{ fontSize: 13, color: '#666', marginBottom: 20 }}>
          These settings control core system behavior. Changes take effect immediately.
        </p>

        <div className="table-container">
          <table>
            <thead>
              <tr><th>Setting</th><th>Value</th><th>Description</th><th>Last Updated</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {configs.map((c) => (
                <tr key={c.configId}>
                  <td><strong>{c.configKey}</strong></td>
                  <td>
                    <input
                      className="form-control"
                      style={{ maxWidth: 200 }}
                      value={editValues[c.configKey] || ''}
                      onChange={(e) => setEditValues({ ...editValues, [c.configKey]: e.target.value })}
                    />
                  </td>
                  <td style={{ fontSize: 13, color: '#666' }}>{c.description || '-'}</td>
                  <td>{new Date(c.updatedAt).toLocaleString()}</td>
                  <td>
                    <button className="btn btn-sm btn-primary" onClick={() => handleSave(c.configKey)}>
                      <FiSave /> Save
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Config;
